<template>
	<div>
		<div>
			<div class="p-6">
				<div style="background: #FFFFFF; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3); border-radius: 5px;padding: 20px;">
					<div class="mb-5">
						<h4 class="uppercase font-bold block text-xl w-full">UPLOAD GIẤY CHUYỂN TIỀN</h4>
					</div>
					<div class="mb-5">
						<div class="mb-2">
							<label for class="text-base vs-input--label"> Nhà cung cấp: </label>
							<v-select
								:clearable="false"
								class="border-none w-full"
								:placeholder="`Chọn nhà cung cấp`"
								v-model="supplier"
								name="supplier"
								:options="$store.state.moduleProduct.suppliers"
								:reduce="(p) => p.id"
								label="name"
								:data-vv-as="'Nhà cung cấp'"
							/>
						</div>
						<div class="mb-5">
							<span class="text-warning text-sm break-normal" style="display: block; text-">(*) UNC upload tương ứng với hóa đơn được chọn</span>
							<!-- <span class="text-warning text-sm break-normal" style="display: block; text-">(*) Số tiền thanh toán là tổng số tiền qua các đợt</span> -->
						</div>
						
						<label for class="text-base vs-input--label"  v-show="payment_nos.length > 0">Hóa đơn chưa thanh toán: </label>
						<label class="text-warning text-sm break-normal" v-show="payment_nos.length == 0 && supplier">Chưa có hóa đơn hoặc đã thanh toán hết</label>
						<label for class="text-base vs-input--label mb-5" style="display: block;" v-show="payment_nos.length > 0 && supplier">Tổng cộng hóa đơn đã chọn: {{$helper.numFormat(totalPaynos)}}</label>

						<vs-row class="mb-2" :key="indextr" v-for="(itemPayment, indextr) in payment_nos">
							<vs-col vs-w="3" style="display: flex; vertical-align: middle;">
								<vs-checkbox :disabled="!isEditablePayno" :name="'payment_'+indextr" v-model="payment_files[itemPayment.id]" color="primary" :id="'payment_'+indextr" :vs-value="itemPayment.id.toString()" />
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer" style="align-self: center">
									{{itemPayment.payment_no}}
								</label>
							</vs-col>
							<vs-col vs-w="2" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer" style="align-self: center">
									{{$helper.momentFormat(itemPayment.payment_date)}}
								</label>
							</vs-col>
							<vs-col vs-w="3" style="display: flex; vertical-align: middle; text-align: right;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer" style="align-self: center">
									{{$helper.numFormat(itemPayment.payment_value)}}
								</label>
							</vs-col>
							<vs-col vs-w="4" style="display: flex; vertical-align: middle;">
								<cbs-input type="text" v-model="payment_ghino[itemPayment.id]" class="w-full" style="align-self: center" placeholder="Số tiền" />
							</vs-col>
							<vs-col vs-w="12" v-if="itemPayment.current_billing" class="m-2">
								<div :key="indexlog" v-for="(itemLog, indexlog) in itemPayment.billing_logs" class="w-full">
									<span v-if="itemLog.payment_value" class="text-sm">Thanh 1 phần ngày {{$helper.momentFormat(itemLog.payment_date)}} với số tiền là {{$helper.numFormat(itemLog.payment_value)}}</span>
								</div>
								<span v-if="itemPayment.current_billing">Số tiền còn lại: {{$helper.numFormat(itemPayment.payment_value - itemPayment.current_billing)}}</span>
							</vs-col>
						</vs-row>
					</div>

					<div class="mb-5" style="align-items: center; align-items: center;display: flex;flex-direction: row;width: 100%;">
						<div v-if="isEditablePayno" @click="uploadChungTu()" :style="{cursor: 'pointer', 'box-shadow': '0px 0px 4px rgba(0, 0, 0, 0.25)', padding: '14px 7px', width: '250px', 'border-radius': '5px', 'text-align': 'center', background: '#FFFFFF', color: '#057FBB', 'font-weight': 700, display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center'}">
							<svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.75 23C6.13125 23 5.60175 22.7799 5.1615 22.3396C4.7205 21.8986 4.5 21.3687 4.5 20.75V17.375H6.75V20.75H20.25V17.375H22.5V20.75C22.5 21.3687 22.2799 21.8986 21.8396 22.3396C21.3986 22.7799 20.8687 23 20.25 23H6.75ZM12.375 18.5V9.33125L9.45 12.2562L7.875 10.625L13.5 5L19.125 10.625L17.55 12.2562L14.625 9.33125V18.5H12.375Z" fill="#057FBB"/>
							</svg>
							Upload ủy nhiệm chi
						</div>
						<div v-if="isEditablePayno" class="ml-3" @click="setPaymentInfo()" :style="{cursor: 'pointer', 'box-shadow': '0px 0px 4px rgba(0, 0, 0, 0.25)', padding: '14px 7px', width: '250px', 'border-radius': '5px', 'text-align': 'center', background: (payment_files && payment_files.length >= 1 ? '#057FBB' : '#D4D4D4'), color: '#FFFFFF', 'font-weight': 700, display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center'}" >
							<svg class="mr-1" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M13.5 17.5219C13.35 17.5219 13.2094 17.4983 13.0781 17.451C12.9469 17.4045 12.825 17.325 12.7125 17.2125L8.6625 13.1625C8.45625 12.9563 8.35313 12.6938 8.35313 12.375C8.35313 12.0563 8.45625 11.7938 8.6625 11.5875C8.86875 11.3813 9.13575 11.2733 9.4635 11.2635C9.792 11.2545 10.0594 11.3531 10.2656 11.5594L12.375 13.6687V5.625C12.375 5.30625 12.483 5.03888 12.699 4.82288C12.9143 4.60763 13.1812 4.5 13.5 4.5C13.8188 4.5 14.0861 4.60763 14.3021 4.82288C14.5174 5.03888 14.625 5.30625 14.625 5.625V13.6687L16.7344 11.5594C16.9406 11.3531 17.208 11.2545 17.5365 11.2635C17.8643 11.2733 18.1312 11.3813 18.3375 11.5875C18.5437 11.7938 18.6469 12.0563 18.6469 12.375C18.6469 12.6938 18.5437 12.9563 18.3375 13.1625L14.2875 17.2125C14.175 17.325 14.0531 17.4045 13.9219 17.451C13.7906 17.4983 13.65 17.5219 13.5 17.5219ZM6.75 22.5C6.13125 22.5 5.60175 22.2799 5.1615 21.8396C4.7205 21.3986 4.5 20.8687 4.5 20.25V18C4.5 17.6812 4.60763 17.4139 4.82288 17.1979C5.03888 16.9826 5.30625 16.875 5.625 16.875C5.94375 16.875 6.21112 16.9826 6.42712 17.1979C6.64237 17.4139 6.75 17.6812 6.75 18V20.25H20.25V18C20.25 17.6812 20.358 17.4139 20.574 17.1979C20.7892 16.9826 21.0562 16.875 21.375 16.875C21.6938 16.875 21.9608 16.9826 22.176 17.1979C22.392 17.4139 22.5 17.6812 22.5 18V20.25C22.5 20.8687 22.2799 21.3986 21.8396 21.8396C21.3986 22.2799 20.8687 22.5 20.25 22.5H6.75Z" fill="white"/>
							</svg>
							Lưu lại
						</div>
						<div v-if="!isEditablePayno" class="ml-3" @click="isEditablePayno = !isEditablePayno" :style="{cursor: 'pointer', 'box-shadow': '0px 0px 4px rgba(0, 0, 0, 0.25)', padding: '14px 7px', width: '250px', 'border-radius': '5px', 'text-align': 'center', background: (payment_files && payment_files.length >= 1 ? '#057FBB' : '#D4D4D4'), color: '#FFFFFF', 'font-weight': 700, display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center'}" >
							<svg class="mr-1" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M13.5 17.5219C13.35 17.5219 13.2094 17.4983 13.0781 17.451C12.9469 17.4045 12.825 17.325 12.7125 17.2125L8.6625 13.1625C8.45625 12.9563 8.35313 12.6938 8.35313 12.375C8.35313 12.0563 8.45625 11.7938 8.6625 11.5875C8.86875 11.3813 9.13575 11.2733 9.4635 11.2635C9.792 11.2545 10.0594 11.3531 10.2656 11.5594L12.375 13.6687V5.625C12.375 5.30625 12.483 5.03888 12.699 4.82288C12.9143 4.60763 13.1812 4.5 13.5 4.5C13.8188 4.5 14.0861 4.60763 14.3021 4.82288C14.5174 5.03888 14.625 5.30625 14.625 5.625V13.6687L16.7344 11.5594C16.9406 11.3531 17.208 11.2545 17.5365 11.2635C17.8643 11.2733 18.1312 11.3813 18.3375 11.5875C18.5437 11.7938 18.6469 12.0563 18.6469 12.375C18.6469 12.6938 18.5437 12.9563 18.3375 13.1625L14.2875 17.2125C14.175 17.325 14.0531 17.4045 13.9219 17.451C13.7906 17.4983 13.65 17.5219 13.5 17.5219ZM6.75 22.5C6.13125 22.5 5.60175 22.2799 5.1615 21.8396C4.7205 21.3986 4.5 20.8687 4.5 20.25V18C4.5 17.6812 4.60763 17.4139 4.82288 17.1979C5.03888 16.9826 5.30625 16.875 5.625 16.875C5.94375 16.875 6.21112 16.9826 6.42712 17.1979C6.64237 17.4139 6.75 17.6812 6.75 18V20.25H20.25V18C20.25 17.6812 20.358 17.4139 20.574 17.1979C20.7892 16.9826 21.0562 16.875 21.375 16.875C21.6938 16.875 21.9608 16.9826 22.176 17.1979C22.392 17.4139 22.5 17.6812 22.5 18V20.25C22.5 20.8687 22.2799 21.3986 21.8396 21.8396C21.3986 22.2799 20.8687 22.5 20.25 22.5H6.75Z" fill="white"/>
							</svg>
							Sửa lại
						</div>
					</div>
					<div id="custom-upload">
						<CbsUploadRefCustom
							value="value"
							:key="timeKey2"
							:isEditable="isEditablePayno"
							v-model="localAttachFile"
							accept="*"
							:limit="10"
							:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
							:dataValue="shippingHackPayments"
						/>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label"> Ghi chú thêm: </label>
						<cbs-input v-model="accountant_note" class="w-full" name="accountant_note" :data-vv-as="'Ghi chú thêm'" :placeholder="`${$t('Input')} ${'Ghi chú thêm'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('accountant_note')">{{ errors.first("accountant_note") }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";
import ListUploadMode from "@/components/cbs-upload-ref/ListUploadMode";

export default {
	name: "AccountUncBB",
	components: { vSelect, SelectAssigned, CbsUploadRefCustom, ListUploadMode },
	props: {
		// isPopupActive: {
		// 	type: Boolean,
		// 	required: true,
		// },
		data: {
			type: Object,
			default: () => {},
		},
		refresh: {
			type: Number,
		},
	},
	data() {
		return {
			supplier: null,
			totalPaynos: 0,
			shippingHackPayments: [],
			data2: {},
			payment_files: [],
			payment_ghino: {},
			payment_nos: [],
			activeShipping: {},
			shippingActiveIndex: 0,
			data2: {},
			cus_name: null,
			supplier_name: null,
			status: 0,
			productName: null,
			timeKey: Date.now(),
			timeKey2: Date.now(),
			photos: [],
			files: [],
			value: {},
			product: null,
			quantity: null,
			price: null,
			address: null,
			note: null,
			accountant_note: null,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			id: 0,
			product_id: 0,
			isEditablePayno: true,
			listShippingsByPmid: [],
			listShippingsByPmidStr: '',
			sohoadonstr: ''
		};
	},
	watch: {
		payment_files(val) {
			// console.log('payment_files: ', val);
			let maps = {};
			for (let kk in this.payment_nos) {
				let itemTmp = this.payment_nos[kk];
				if (itemTmp) {
					maps[itemTmp.id] = itemTmp;
				}
			}
			if (Object.keys(maps).length) {
				let total = 0;
				for (let k in val) {
					let kk = val[k];
					if (kk && maps.hasOwnProperty(kk)) {
						total += parseInt(maps[kk].payment_value);
					}
				}				
				this.totalPaynos = total;
			}
		},
		supplier(val) {
			console.log('supplier: ', val);
			this.getPaymentNos();
		},
	},
	computed: {
		localAttachFile: {
			get() {
				console.log('localAttachFile this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				console.log('localAttachFile set.value: ' , val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				console.log('this.files: ', this.files);
				// this.setPaymentInfo();
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
	},
	methods: {
		uploadChungTu() {
			document.querySelector('#custom-upload .el-upload__input').click();
		},
		getValueByKey(order, key) {
			if (order.type == 1 && order.matching_buy) {
				return order.matching_buy[key] || '-';
			}
			if (order.type == 2 && order.matching) {
				return order.matching[key] || '-';
			}

			return '';
		},
		getDataMatching(key) {
			if (this.data2 && this.data2.matching && this.data2.matching.hasOwnProperty(key)) {
				return this.data2.matching[key];
			}
			return '';
		},
		async getPaymentNos() {
			let id = this.supplier;
			console.log('getPaymentNos: ', id);
			this.$vs.loading();
			try {
				if (id) {
					this.$store.dispatch("moduleProduct/getPaymentNos", id).then(response => {
						console.log('getPaymentNos: ', response);
						this.payment_nos = response;

						let uncs = [];
						for (let k in response) {
							let p = response[k];
							if (p) {
								uncs = [...uncs, ...(p.uncs || [])];
							}
						}
						let finalUncs = uncs.reverse();
						this.shippingHackPayments = finalUncs;
						if (this.files.length < 1) {
							this.files = finalUncs;
						}
						console.log('finalUncs: ', finalUncs);
						this.$vs.loading.close();
					});
				}
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getOrder(withoutIndex = false) {
			if (!this.id) {
				return;
			}
			console.log('getOrder');
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleProduct/getOrderById", this.id).then(response => {
					// this.sell = response;
					// if (response && response.photos) {
					// 	this.activePhoto = response.photos[0];
					// }
					this.data2 = response;
					if (!withoutIndex) {
						this.shippingActiveIndex = 0;
						this.getAcctiveShipping();
					}
					console.log('getOrderById: ', response);
					this.getPaymentNos();
					this.getShippingListName();

					const { supplier, product, quantity, price, cus_note, address, photos = [], id = 0, supplier_name, supper_phone, supper_mst, supplier_bankaccount, supplier_bankname, supplier_bankowner, shipping_method,
						shipping_options, type, state_id, district_id, prevent_slit, orderNow = 0, require_qc = 0, buy_id = 0, status = 0, cus_name, payment_nos, accountant_note
					} = this.data2;
					this.orderNow = orderNow;
					if (status) {
						this.status = status;
					} else {
						this.status = 0;
					}
					// console.log('payment_nos: ', payment_nos);
					// console.log('this.payment_files: ', this.payment_files);
					if (payment_nos && payment_nos.length) {
						this.isEditablePayno = false;
						let pp = [];
						let totalPaynos = 0;
						for (let k in payment_nos) {
							let p = payment_nos[k];
							// pp.push(p.id);
							pp[p.id] = p.id;
							totalPaynos+= parseInt(p.payment_value);
						}
						this.totalPaynos = totalPaynos;
						this.payment_files = pp;
					} else {
						this.payment_files = [];
					}
					console.log('this.payment_files: ', this.payment_files);
					if (product) {
						this.product = product.id;
					} else {
						this.product = null;
					}
					if (accountant_note) {
						this.accountant_note = accountant_note;
					} else {
						this.accountant_note = null;
					}
					if (supplier) {
						this.supplier = supplier.id;
					} else {
						this.supplier = null;
					}
					
					if (quantity) {
						this.quantity = quantity;
					} else {
						this.quantity = null;
					}
					if (shipping_options) {
						shippingOptions = shipping_options;
					}
					else {
						shippingOptions = {};
					}
					if (price) {
						this.price = price;
					} else {
						this.price = null;
					}
					if (cus_name) {
						this.cus_name = cus_name;
					} else {
						this.cus_name = null;
					}
					if (supplier_name) {
						this.supplier_name = supplier_name;
					} else {
						this.supplier_name = null;
					}
					if (supper_phone) {
						this.supper_phone = supper_phone;
					} else {
						this.supper_phone = null;
					}
					if (supper_mst) {
						this.supper_mst = supper_mst;
					} else {
						this.supper_mst = null;
					}
					if (supplier_bankaccount) {
						this.supplier_bankaccount = supplier_bankaccount;
					} else {
						this.supplier_bankaccount = null;
					}
					if (supplier_bankname) {
						this.supplier_bankname = supplier_bankname;
					} else {
						this.supplier_bankname = null;
					}
					if (supplier_bankowner) {
						this.supplier_bankowner = supplier_bankowner;
					} else {
						this.supplier_bankowner = null;
					}
					if (address) {
						this.address = address;
					} else {
						this.address = null;
					}
					if (cus_note) {
						this.cus_note = cus_note;
					} else {
						this.cus_note = null;
					}
					if (photos) {
						this.photos = photos;
					} else {
						this.photos = null;
					}
					if (id) {
						this.id = id;
					} else {
						this.id = null;
					}
					if (shipping_method) {
						this.shipping_method = shipping_method;
					}
					if (state_id) {
						this.province = state_id;
					} else {
						this.province = null;
					}
					if (district_id) {
						this.district = district_id;
					} else {
						this.district = null;
					}
					if (prevent_slit) {
						this.prevent_slit = 1;
					} else {
						this.prevent_slit = 0;
					}
					if (require_qc) {
						this.require_qc = 1;
					} else {
						this.require_qc = 0;
					}
					
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		getProductName() {
			if (!this.product_id) {
				return '';
			}
			let pName = '';
			for (let k in this.$store.state.moduleProduct.products) {
				let p = this.$store.state.moduleProduct.products[k];
				if (p && p.id == this.product_id) {
					pName = p.name;
					return pName;
				}
			}
			return pName;
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.address = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						photos: this.files.map(item => item.id),
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async setPaymentInfo() {
			this.$vs.loading();
			let ids = [];
			this.payment_files.map(ff => {
				if (ff) {
					ids.push(ff);
				}
			});
			
			try {
				// this.$vs.loading();
				let files = this.files.map(f => {
					return f.id;
				});
				console.log('setPaymentInfoAqua: ', files);
				let payload = {id: this.supplier, files: files, payment_nos: ids, accountant_note: this.accountant_note, payment_ghino: this.payment_ghino};
				console.log(payload);
				await this.$store.dispatch("moduleProduct/setPaymentInfoAqua", payload);
				this.$vs.loading.close();
				this.$helper.notifySuccess({ context: this, options: {
					text: 'Đã lưu',
				}, });
				this.payment_nos = [];
				this.files = [];
				this.payment_files = [];
				this.accountant_note = null;
				this.getPaymentNos();
			} catch (error) {
				console.log('error: ', error);
				this.$helper.notifyWarning({ context: this, options: {
					text: error,
				}, });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
	created() {
		console.log('created: ', Date.now());
		this.getOrder(true);
	}
};
</script>

<style>
#custom-upload .el-upload--picture-card {
	display: none;
}
</style>